import { Box, Dialog, DialogContent, IconButton, Typography, List, ListItem, Button, Link } from "@mui/material";
import { useEffect, useState } from "react";
import Transition from "../Transition";
import { CrossIcon } from "../../assets/icons";

interface IProps {
  close: Function;
  open: boolean;
}

export default function Trial(props: IProps) {
  const [open, setOpen] = useState(props.open);
  const handleClose = (e: React.MouseEvent, reason?: "backdropClick" | "escapeKeyDown") => {
    e.stopPropagation();
    props.close();
  };

  useEffect(() => {
    setOpen(props.open);
  }, [props]);

  return (
    <Dialog
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "16px",
          boxShadow: "0px 12px 24px 0px rgba(0, 0, 0, 0.15)",
          padding: "24px",
          width: "100%",
          margin: "4px",
        },
        "& .MuiDialogContent-root,& .MuiDialogActions-root": {
          padding: 0,
        },
        "& .MuiDialogContent-root": {
          color: "text.fontDarkest",
          textAlign: "center",
          fontSize: "14px",
          width: "100%",
          display: "flex",
        },
      }}
      open={open}
      TransitionComponent={Transition}
      onClose={handleClose}
    >
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: "text.fontDarkest",
        }}
      >
        <CrossIcon />
      </IconButton>
      <DialogContent>
        <Box
          sx={{ display: "flex", gap: "24px", flexDirection: "column", justifyContent: "center", alignItems: "center" }}
        >
          <Typography sx={{ fontSize: "30px", fontWeight: 600, color: "primary.main" }}>
            Trial Mode Notification
          </Typography>
          <Typography sx={{ fontSize: "18px" }}>
            To ensure you are prepared to proceed, kindly verify that the following tasks have been fully completed:
          </Typography>
          <ul>
            <li style={{ fontSize: "16px", textAlign: "left" }}>
              All meals have been added with accurate images, nutritional details, and ingredients.
            </li>
            <li style={{ fontSize: "16px", textAlign: "left" }}>
              Comprehensive meal plans and plan options have been created.
            </li>
            <li style={{ fontSize: "16px", textAlign: "left" }}>
              Meal schedules have been properly defined and finalized.
            </li>
          </ul>
          <Typography>
            If you have completed these tasks, please contact our team by sending an email to{" "}
            <Link
              sx={{ color: "primary.main", textDecoration: "none", fontWeight: 600 }}
              href="mailto:contact@rejeem.app"
            >
              contact@rejeem.app
            </Link>{" "}
            for further assistance.
          </Typography>
          <Button sx={{ width: "200px" }} onClick={handleClose} color="primary" variant="contained" disableElevation>
            I Understand
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
